import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanTime'
})
export class HumanTime implements PipeTransform {

  pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }
  transform(value: any, args?: any): any {
    if (typeof value === 'undefined') {
      return 'N/A';
    }
    let min = (value / 1000 / 60) << 0,
      sec = Math.round((value / 1000) % 60);

    return this.pad(min) + ':' + this.pad(sec);
  };
}



// WEBPACK FOOTER //
// ./src/app/human-time.pipe.ts